import { Theme } from "@material-ui/core";
import { createStyles } from '@material-ui/core/styles';
import { styledBy } from "../../models/AlmeColorMapping";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, typography }: Theme) {

    return createStyles({
        utilityBar: {
            color: styledBy('color', {
                default: palette.text.primary,
                divider: palette.text.primary,
                initial: palette.text.primary,
                paper: palette.text.primary,
                primary: palette.primary.contrastText,
                secondary: palette.secondary.contrastText,
            }),
            backgroundColor: styledBy('color', {
                default: palette.background.default,
                divider: palette.divider,
                initial: 'initial',
                paper: palette.background.paper,
                primary: palette.primary.main,
                secondary: palette.secondary.main,
            }),
            borderBottom: styledBy('borderColor', {
                default: `1px solid`,
                divider: `1px solid ${palette.augmentColor({ main: palette.divider }).dark}`,
                initial: 'none',
                paper: `1px solid ${palette.augmentColor({ main: palette.background.paper }).dark}`,
                primary: `1px solid ${palette.primary.main}`,
                secondary: `1px solid ${palette.secondary.main}`,
            }),
            marginBottom: '12px',
        },
        utilityBarButton: {
            whiteSpace: "break-spaces",
            textAlign: "center",
            color: styledBy('color', {
                default: palette.text.primary,
                divider: palette.text.primary,
                initial: palette.text.primary,
                paper: palette.text.primary,
                primary: palette.primary.contrastText,
                secondary: palette.secondary.contrastText,
            }),
        },
    });
}
